import { format, parse } from 'date-fns';
import { ru } from 'date-fns/locale';

import useVueProxy from '@ve/services/useVueProxy';
import {
    computed, ref, SetupContext, toRefs, unref, watch,
} from 'vue';
import { DatesAndPricesItem } from '@ve/components/hotel/datesTabs/common/types/IMapForDatesTabsStore';

export default (props: {
    selectedDate: string;
    tabData: DatesAndPricesItem;
    searchDates: string[];
    loadingState: string;
}, {
                    emit,
                }: SetupContext) => {
    const {
        selectedDate,
        tabData,
        searchDates,
        loadingState,
    } = toRefs(props);
    const { $root } = useVueProxy();

    const searchInProgress = ref(false);

    const isSelected = computed(() => unref(tabData).startDate === unref(selectedDate));
    const formattedDate = computed(() => format(parse(unref(tabData).startDate, 'yyyy-MM-dd', new Date()), 'd MMMM, EEEEEE', { locale: ru }));

    const dateAlreadySearched = computed(() => !!~unref(searchDates).indexOf(unref(tabData).startDate));
    const isDisabled = computed(() => !unref(dateAlreadySearched) && unref(loadingState) !== 'finished');

    watch(loadingState, (loadingStateData) => {
        if (loadingStateData === 'finished') {
            searchInProgress.value = false;
        }
    });

    const selectDate = () => {
        if (!unref(isDisabled)) {
            const { startDate, price } = unref(tabData);
            if (unref(dateAlreadySearched)) {
                emit('on-date-select', { startDate, price });
            } else {
                searchInProgress.value = true;
                emit('on-date-select', { startDate, price });
                $root?.$emit('start-new-search', parse(startDate, 'yyyy-MM-dd', new Date()));
            }
        }
    };

    return {
        isSelected,
        formattedDate,
        dateAlreadySearched,
        isDisabled,
        searchInProgress,
        selectDate,
    };
};